import { render } from "./MetabaseSettings.vue?vue&type=template&id=6b4ac85c&scoped=true"
import script from "./MetabaseSettings.vue?vue&type=script&lang=js"
export * from "./MetabaseSettings.vue?vue&type=script&lang=js"

import "./MetabaseSettings.vue?vue&type=style&index=0&id=6b4ac85c&scoped=true&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b4ac85c"]])

export default __exports__